module.exports = __webpack_public_path__ + "img/respondent-loading.fe18824e.svg";